<template>
  <div id="app">
    <h1 class="intro">
      Hi,<br>We are DOT Underscore
      <br />Front-end studio by <a href="#" @click="darkmode = false">day</a>,<br>
      <span class="xsecondary-info">UX & UI Studio <br>by <a href="#" @click="darkmode = true">night</a>.</span>
    </h1>
    <CircleAnimation v-on:toggleDarkmode="toggleDarkmode" v-bind:darkmode="darkmode" />
  </div>
</template>

<script>
import CircleAnimation from "./components/CircleAnimation.vue";

export default {
  name: "app",
  data() {
    return {
      darkmode: true
    };
  },
  components: {
    CircleAnimation
  },
  methods: {
    toggleDarkmode() {
      this.darkmode = this.darkmode ? false : true;
    }
  },
  watch: {
    darkmode(val) {
      if (val) {
        document.body.classList.remove("white-theme");
      } else {
        document.body.classList.add("white-theme");
      }
    }
  }
};
</script>

<style lang="scss">
@import "~normalize.css";

html,
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  cursor: url("/img/cursor-white.svg") 6 6, auto;
}

body {
  background: #000;
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
  font-family: $font-family;
  font-weight: $fw-regular;
  font-size: $fs-base;
  color: #fff;
  letter-spacing: 0;
  line-height: 1.6;
  transition: color $main-transition-fast;

  #app {
    width: 100vw;
    height: 100vh;
  }

  span.secondary-info {
    opacity: 0.3;
    // font-size: 0.5em;
  }

  .intro {
    position: absolute;
    margin-left: 10%;
    margin-top: -140px;
    // width: 60%;
    max-width: 600px;
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.4;
    z-index: 10;
    @include center(y);

    @include respond(max-m) {
      margin-left: 6%;
      padding-right: 1%;
    }

    a {
      &:before {
        height: 2px;
      }

      &:hover {
        &:before {
          height: calc(100% - 5px);
        }
      }
    }
  }

  a {
    position: relative;
    color: #fff;
    text-decoration: none;
    padding-bottom: 2px;
    transition: color $main-transition-fast;

    &:before {
      position: absolute;
      content: " ";
      height: 1px;
      width: 100%;
      background: #fff;
      mix-blend-mode: difference;
      left: 0;
      bottom: 0;
      transition: background $main-transition-fast,
        height $main-transition-xfast;
    }

    &:hover {
      &:before {
        height: 100%;
      }
    }
  }

  &.white-theme {
    background: #fff;
    color: #000;
    cursor: url("/img/cursor-black.svg") 6 6, auto;

    a {
      color: #000;
      transition: color $main-transition-xfast;

      &:hover {
        color: #fff;
      }

      &:before {
        background: #000;
      }
    }
  }

  .container {
    position: relative;
    margin: 0 auto;
    padding: 0 $spacing;

    @include respond(min-l) {
      max-width: 960px;
      width: 960px;
    }

    @include respond(min-xl) {
      max-width: 1152px;
      width: 1152px;
    }

    @include respond(min-xxl) {
      max-width: 1344px;
      width: 1344px;
    }
  }

  h1 {
    margin: 0 0 $spacing 0;
    font-size: $fs-xxxxl;
    font-weight: $fw-demi;
    line-height: 1;
    letter-spacing: -0.8px;
  }

  h2 {
    // font-size: 2rem;
  }

  div.grad-line {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100vh;
    width: 5px;
    background: linear-gradient(
      180deg,
      $c-primary 0%,
      $c-secondary 50%,
      $c-tertiary 100%
    );
    background-size: 600% 600%;
    animation: gradientMove 10s ease infinite;
    z-index: 10;
  }

  .content {
    transform: translateY(-150px);
    text-align: right;

    .guide-line {
      display: block;
      position: absolute;
      right: 0;
      height: 100%;
      width: 1px;
      background: linear-gradient(
        0deg,
        $c-primary 0%,
        $c-secondary 50%,
        $c-tertiary 100%
      );
    }

    .content-holder {
      font-weight: bold;
      display: flex;
      flex-direction: row-reverse;
      height: 150px;
      align-items: flex-end;

      .links {
        padding-bottom: 20px;
        // flex-direction: fle
      }
    }
  }

  @keyframes gradientMove {
    0% {
      background-position: 51% 0%;
    }
    50% {
      background-position: 50% 100%;
    }
    100% {
      background-position: 51% 0%;
    }
  }
}
</style>
